import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ArrowLeftIconComponent, ViewIconComponent } from '@kuiper/icons';
import { PermissionsDirective } from '../../../../../../ui-components/directives/permissions/permissions.directive';
import { AppPermissions } from '../../../../../common/constants/app-permissions';
import { EMPLOYEE_ROUTES } from '../../../../../common/constants/employee.routing.constants';
import { RequestTypeEnum } from '../../../../../common/enums/request-type';
import { RequestCard } from '../../../../../common/models/request.model';
import { PreviousRouteService } from '../../../../../common/services/previous-route/previous-route.service';
import { RequestService } from '../../../../../common/services/request/request.service';

/** UI_Version_2 workflow actions: view details, and start a request when the workflow allows it. */
@Component({
  selector: 'lib-request-actions',
  imports: [
    RouterLink,
    TranslocoPipe,
    PermissionsDirective,
    ViewIconComponent,
    ArrowLeftIconComponent,
  ],
  templateUrl: './request-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'flex items-center gap-sm shrink-0' },
})
export class RequestActionsComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly previousRouteService = inject(PreviousRouteService);
  private readonly requestService = inject(RequestService);

  readonly request = input.required<RequestCard>();

  protected readonly appPermissions = AppPermissions;
  protected readonly detailsPath = computed(() =>
    this.requestService.navigationPath(
      `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/${this.request().id}`
    )
  );

  savePreviousParams(): void {
    this.previousRouteService.setPreviousParams(
      this.route.snapshot.queryParams
    );
  }

  triggerRequest(): void {
    this.savePreviousParams();
    const subPath = `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/${this.request().id}/${RequestTypeEnum.TRIGGER}`;
    this.router.navigate([this.requestService.navigationPath(subPath)]);
  }
}
